// extracted by mini-css-extract-plugin
export default {"stats":"StatCard_stats__jXIMy","value":"StatCard_value__LqlBV","tag":"StatCard_tag__xgNgv","label":"StatCard_label__lZM76"};